import * as types from './mutation-types';

export default {
  [types.SET_FREIGHT_COLLECTION](state, payload) {
    state.freightCollection = payload;
  },
};
